import React, { useEffect, useState } from 'react';
import { get, isEmpty } from 'lodash';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { timerData } from '../../../../actions/digitalClassActions';
import { dateFormat } from '../../../../api/dateFormat';
// Material Imports
import Grid from '@material-ui/core/Grid';
// Components
import TimerCard from '../../../../components/TimerCard.js';
import { fetchLiveClassRecordingsData } from '../../../../actions/liveClassRecordingsActions';
import { Link } from 'react-router-dom';
import PageHeading from '../../../../components/PageHeading';
import NoData from '../../../../components/NoData';
import LoadingSkeleton from '../../../../components/LoadingSkeleton';

export default function LiveClassLayout() {
  // State
  const [isFetching, setIsFetching] = useState(false);

  const loginData = useSelector(state =>
    get(state, 'loginReducer.data.jwt', {})
  );
  // Redux
  const dispatch = useDispatch();

  const liveClassData = useSelector(state =>
    get(state, 'liveClassRecordingsReducer.data', {})
  );

  const errorMessage = useSelector(state =>
    get(state, 'liveClassRecordingsReducer.errorMessage', '')
  );

  //functions
  useEffect(() => {
    setIsFetching(true);
    fetchLiveClassRecordingsData(loginData, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const handler = expiry => {
    dispatch(timerData(expiry));
  };
  const callback = () => {
    fetchLiveClassRecordingsData(loginData, dispatch);
  };

  const populateDigitalLiveClassList = () => {
    let list = [];
    liveClassData.map((data, index) => {
      let classList = [];
      data.listClass.map((classes, classIndex) => {
        let uniquekey = `${index}${classIndex}`;
        classList.push(
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={classes.RemainingTime}
            className="flex"
          >
            <Link
              to={
                classes.ModuleCode === null
                  ? '/live-class-recordings/' + classes.UniqueCode
                  : '/live-class-recordings/' +
                    classes.UniqueCode +
                    '/' +
                    classes.ModuleCode
              }
              className="timer-card-container"
            >
              <TimerCard
                key={uniquekey}
                subject={classes.SubjectName}
                dateTime={`${dateFormat(data.ClassDate)} at ${
                  classes.ClassTime
                }`}
                topic={classes.ModuleNo}
                handler={() => handler(classes.Expiry)}
                start={classes.RemainingTime < 0 ? 'EXPIRE IN' : 'START IN'}
                initialTime={
                  classes.RemainingTime < 0
                    ? classes.Expiry * 1000
                    : classes.RemainingTime * 1000
                }
                callback={callback}
              />
            </Link>
          </Grid>
        );
      });
      return list.push(
        <React.Fragment key={index}>{classList}</React.Fragment>
      );
    });
    return list;
  };
  return (
    <React.Fragment>
      <PageHeading titlePrimary="Live Class" titleSecondary="Recordings" />

      {isFetching ? (
        <LoadingSkeleton type="bigcardlist" />
      ) : !isEmpty(liveClassData) ? (
        <Grid container spacing={2}>
          {populateDigitalLiveClassList()}{' '}
        </Grid>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
    </React.Fragment>
  );
}
